import { createPageAnalyticsFn } from 'src/libs/Analytics';

type CandidateManagementLinkAnalyticEvents =
  | {
      event: 'searched_location_pressed';
      attributes: {
        searchLocationId: string[];
        locationIdSelected: string;
        filterSelection: 'Selected' | 'Deselected';
      };
    }
  | {
      event: 'searched_nationality_pressed';
      attributes: {
        searchNationalityId: string[];
        nationalityIdSelected: string;
        filterSelection: 'Selected' | 'Deselected';
      };
    }
  | {
      event: 'candidate_management_freemium_pop_up_displayed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    }
  | {
      event: 'candidate_management_freemium_pop_up_upgrade_pressed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    }
  | {
      event: 'alert_dismiss_pressed';
      attributes: {
        seekListingId: number;
        alertShownMessageCode:
          | 'Candidate Management - Freemium Upgrade - Hard to Fill'
          | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
      };
    };

interface CandidateManagementViewAnalyticEvents {
  event: 'candidate_management_freemium_pop_up_displayed';
  attributes: {
    seekListingId: number;
    alertShownMessageCode:
      | 'Candidate Management - Freemium Upgrade - Hard to Fill'
      | 'Candidate Management - Freemium Upgrade - Urgent Hiring';
  };
}

export const createPageAnalytics = createPageAnalyticsFn<
  CandidateManagementLinkAnalyticEvents,
  CandidateManagementViewAnalyticEvents
>({
  siteSubsection: 'candidate',
});
